import { c as _c } from "react/compiler-runtime";
import Button from '@classify/react-core-components/Button';
import Box from '@classify/react-core-components/Box';
import Typography from '@classify/react-core-components/Typography';
import { styled } from '@classify/react-core-components/styles';
import type { Theme } from '@classify/react-core-components/styles';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import type { EmbeddedChapterTranslations } from '../../../types';
const CardRoot = styled(Box)(({
  theme
}: {
  theme: Theme;
}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  gap: theme.spacing(1),
  padding: theme.spacing(2)
}));
type EmbeddedChapterLoadErrorCardProps = {
  href: string;
  translations: EmbeddedChapterTranslations;
};
const EmbeddedChapterLoadErrorCard = t0 => {
  const $ = _c(11);
  const {
    href,
    translations
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      mt: 0,
      mb: 0
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== translations.loadErrorTitle) {
    t2 = <Typography variant="body1" sx={t1}>{translations.loadErrorTitle}</Typography>;
    $[1] = translations.loadErrorTitle;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <OpenInNewIcon sx={{
      fontSize: 18
    }} />;
    t4 = {
      alignSelf: "flex-start"
    };
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] !== href || $[6] !== translations.openInNewTab) {
    t5 = <Button component="a" href={href} target="_blank" rel="noopener noreferrer" variant="secondary" endIcon={t3} sx={t4}>{translations.openInNewTab}</Button>;
    $[5] = href;
    $[6] = translations.openInNewTab;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t2 || $[9] !== t5) {
    t6 = <CardRoot>{t2}{t5}</CardRoot>;
    $[8] = t2;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
export default EmbeddedChapterLoadErrorCard;